import type { CSSObject } from 'styled-components';
import '@xyflow/react/dist/style.css';
import {
	NODE_HEIGHT,
	NODE_WIDTH,
} from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/Nodes.tsx';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

const { colors } = defaultTheme.v3;

/** The group-structure surface: node sizing the layout depends on, plus the hover treatment. */
export const CAP_CHART_SURFACE_STYLES = {
	'.react-flow__node': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: `${NODE_WIDTH}px`,
		height: `${NODE_HEIGHT}px`,

		'&.hovered': {
			zIndex: '1003 !important',

			"&.debt div[data-handleid='source-debt']": {
				backgroundColor: `${colors.blue[6]} !important`,
				transition: 'background-color 0.2s ease-in-out',
			},
		},
	},

	'.react-flow__handle': {
		height: 0,
		width: 0,
		minWidth: 0,
		minHeight: 0,
		border: 'none',
	},

	'.react-flow__edges svg': {
		overflow: 'visible !important',
	},

	'.react-flow__edges svg:has(.react-flow__edge.hovered), .react-flow__edges svg:hover': {
		zIndex: '1002 !important',
	},

	'.react-flow__edge.hovered:hover, .react-flow__edge.hovered': {
		path: {
			stroke: `${colors.blue[6]} !important`,
			transition: 'stroke 0.2s ease-in-out',
		},

		'.react-flow__edge-textwrapper': {
			rect: {
				stroke: `${colors.blue[6]} !important`,
				fill: `${colors.blue[0]} !important`,
				transition: 'stroke fill 0.2s ease-in-out',
				zIndex: '1004 !important',
			},

			text: {
				fill: `${colors.blue[6]} !important`,
				transition: 'fill 0.2s ease-in-out',
			},
		},
	},
} satisfies CSSObject;
